import i18n from "@/i18n";
import { Dictionary } from "data/types/index";
import { MessageTypeEnum } from "./enums/MessageTypeEnum";
import { ActionStateEnum } from "./enums/operStateEnum";
import { IActionModel } from "./IActionModel";

/** Базовая модель операции */
export class ActionModel implements IActionModel {
  /**Набор данных для отправки на сервер */
  Data: Dictionary<any> = {};

  /**Признак необходимости подтверждения */
  _isNeedConfirm: boolean = false;

  /**Код подтверждения */
  VerifyCode: string = "";

  /**Правила заполнения кода подтверждения */
  VerifyCodeRules: Array<any> = [
    () => {
      const regex: RegExp = new RegExp(/^[\d]{4,6}$/);
      return (
        regex.test(this.VerifyCode) ||
        i18n.t("main.operation.errors.invalidCode")
      );
    }
  ];

  /**Количество попыток ввода кода подтверждения */
  TryCount: number = 3;

  /**Статус запроса */
  _actionState: ActionStateEnum = ActionStateEnum.Init;

  /**Сообщение (ответ сервера) */
  ActionStateText: string = "";

  /**Признак новой операции */
  get IsInit(): boolean {
    return this._actionState == ActionStateEnum.Init;
  }

  /** Признак подтверждения операции */
  get IsConfirm(): boolean {
    return this._actionState == ActionStateEnum.Confirm;
  }

  /**Признак успешного исполнения операции*/
  get IsSuccess(): boolean {
    return this._actionState == ActionStateEnum.Success;
  }

  /** Признак ошибки совершения операции */
  get IsError(): boolean {
    return this._actionState == ActionStateEnum.Error;
  }

  /** Статус операции на исполнении */
  get IsExecuting(): boolean {
    return this._actionState == ActionStateEnum.Executing;
  }

  /**Тип сообщения сервера */
  MsgType: MessageTypeEnum = MessageTypeEnum.Info;
}
